import { render } from "./FriendSelectComponent.vue?vue&type=template&id=151b4a7b&scoped=true"
import script from "./FriendSelectComponent.vue?vue&type=script&lang=js"
export * from "./FriendSelectComponent.vue?vue&type=script&lang=js"

import "./FriendSelectComponent.vue?vue&type=style&index=0&id=151b4a7b&lang=scss&scoped=true"

import exportComponent from "C:\\www\\farming_chat_pc_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151b4a7b"]])

export default __exports__